import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { getUser } from "../../../apis/auth";
import { useHistory, Link } from "react-router-dom";
import Button from "../../../components/Button"
import consultingPopup from "../../../utils/consulting";
// import { getCompanyToken } from "../../../apis/companies";

const FirstLogin = () => {
  const history = useHistory();
  const user = getUser();
  const [name, setName] = useState("");
  const radioOptions = [
    { label: "회사에 소속된 직원입니다", value: 1, path: "/path1" },
    { label: "기업등록을 원합니다", value: 2, path: "/path2" },
  ];

  const [selectedValue, setSelectedValue] = useState({
    label: "회사에 소속된 직원입니다",
    value: 1,
    path: "/path1",
  });

  useEffect(() => {
    setName(get(user, "name"));
  }, [user]);

  useEffect(() => {
    //console.log(selectedValue)
  }, [selectedValue])

  return (
    <div className="page-layout">
      <div className="FirstLogin">
        <p className="title">반가워요, {name}님</p>
        <p className="sub-title">해당되는 것을 선택해주세요</p>
        {radioOptions.map((option, idx) => (
          <div className="radio-wrap" key={idx}>
            <input
              type="radio"
              id={`radio-btn-${idx}`}
              name="radio"
              value={option.value}
              onChange={() => setSelectedValue(option)}
              checked={selectedValue.value === option.value}
            />
            <label className="select-company-wrap" htmlFor={`radio-btn-${idx}`}>
              <span className="radio-label">{option.label}</span>
            </label>
          </div>
        ))}
        <div className="btn-wrap clear">
          <Button
            size="lg"
            className="w-full mt-24"
            label={selectedValue.value === 1 ? '직원등록 요청하기' : '신규기업 등록하기'}
            onClick={() => {
              switch (selectedValue.value) {
                case 2:
                  history.push("/create-company");
                  break;
                default:
                  history.push("/join-company");
                  break;
              }
            }}
          />
        </div>
        <div className="divider" />
        <div className="inquire-wrap float-left">
          <div className="inquire-button-wrap">
            <span
              className="cursor-pointer"
              onClick={() => {
                consultingPopup(true)
              }}
            >WeCake에 문의하기</span>
          </div>
        </div>
        <div className="inquire-wrap float-right">
          <div className="logout-button-wrap">
            <Link to="/logout">로그아웃</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstLogin;
